<template>
  <div v-if="lotlog">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>Codice Lotto:</label>
          <input type="text" class="form-control" v-model="lotlog.lotCode" />
        </div>
        
        <div class="form-group">
          <label>Data Inizio:</label>
          {{ lotlog.startDate | moment("DD/MM/YYYY HH:mm") }}
          <!--<b-form-datepicker v-model="lotlog.startDate" class="mb-2" disabled :date-format-options="{ weekday: 'short', month: 'long' }"></b-form-datepicker>-->
        </div>
       
        <div class="form-group">
          <label>Data Fine:</label>
          <!--<b-form-datepicker v-model="lotlog.endDate" class="mb-2"></b-form-datepicker>-->
          {{ lotlog.endDate | moment("DD/MM/YYYY HH:mm") }}
        </div>
        <div class="form-group">
          <label>Stima Fine:</label>
          {{lotlog.estimatedEndDate || 'Non definita'}}
          <label>(calcolata il:</label>
          {{lotlog.estimatedEndDate || 'Non definita'}})
        </div>
        <div class="form-group">
          <label>Stato:</label>
          <b-form-select v-model="lotlog.status" :options="['OPEN','CLOSED']"></b-form-select>
        </div>
        
        <!--<div class="form-group">
          <label>Utente:</label>
          <input type="text" class="form-control" v-model="lotlog.user" />
        </div>-->
      </div>
      <div class="col-sm-6">
        
        <div class="form-group">
          <label>Prodotto:</label>
          <b-form-select v-model="lotlog.product" :options="['Alpino [AL1]','Dolomiti [DO2]','Rosè [RO3]','Brut [BR4]']" :disabled="(!!lotlog._id)"></b-form-select>
        </div>
        <div class="form-group"> <!-- :disabled="(lotlog.status =='CLOSED'||  !!lotlog._id)" -->
          <label>Alcol Desiderato:</label>
          <input type="number" class="form-control" v-model.number="lotlog.desiredAlcohol" 
          />
        </div>
        <div class="form-group">
          <label>Data prontezza desiderata:</label>
          <b-form-datepicker
            v-model="lotlog.desiredReadyDate"
            class="mb-2"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            placeholder="Seleziona una data"
          ></b-form-datepicker>
        </div>
        <div class="form-group">
          <label>Tolleranza alcol (°):</label>
          <input
            type="number"
            step="0.1"
            class="form-control"
            v-model.number="lotlog.alcholTollerance"
          />
          <small class="text-muted">Predefinito 0.5 se non impostato.</small>
        </div>
          
        
        <div v-if="showData">
          <!--<table class="table table-sm mt-2">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Temperatura</th>
                <th>Alcol Ebul.</th>
                <th>Bx</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in lotlog.data" :key="idx">
                <td>{{ row.timesamp | moment("DD/MM/YYYY HH:mm") }}</td>
                <td>{{ row.temperature }}</td>
                <td>{{ row.AlcholEbul }}</td>
                <td>{{ row.bx }}</td>
              </tr>
            </tbody>
          </table>-->

          

        
        <!--<b-button size="sm" variant="info" @click="showData = !showData">Vedi tutti</b-button>-->
        


        </div>
      </div>

      <div class="col-sm-12">


        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Dati Lotto</h5>
          
        </div>

        <vue-good-table
            :columns="tableColumns"
            :rows="lotlog.data"
            styleClass="vgt-table striped condensed"
              compactMode>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-button class="btn btn-outline-danger" @click="deleteRow(props.row.originalIndex)" >X</b-button>
                </span>
                <span v-else-if="props.column.field == 'timesamp'" >
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="lotlog.data[props.row.originalIndex].timesamp"
                    disabled=true
                  />
                </span>
                <span v-else-if="['temperature','targetTemperature','AlcholEbul','bx'].includes(props.column.field)">
                  <b-form-input
                    type="number"
                    size="sm"
                    v-model.number="lotlog.data[props.row.originalIndex][props.column.field]"
                    disabled=true
                  />
                </span>

                
              </template>
          </vue-good-table>
          <div class="row">
            <div class="col-sm-12">
              
            </div>
          </div>
          <div class="row">

            <div class="col-sm-3">
              <b-form-checkbox v-model="targetOnlyMode" switch>
                IMPOSTATA TEMPERATURA
              </b-form-checkbox>
            </div>

            <div class="col-sm-3" :hidden="targetOnlyMode">
              <label>Temperatura rilevata:</label>
              <input type="number" class="form-control" v-model="addingData.temperature"   />
            </div>
            <div class="col-sm-3" :hidden="!targetOnlyMode">
              <label>Temperatura Target:</label>
              <input type="number" class="form-control" v-model="addingData.targetTemperature"  />
            </div>
            <div class="col-sm-3" :hidden="targetOnlyMode">
              <label>Alcol Ebul.:</label>
              <input type="number" class="form-control" v-model="addingData.AlcholEbul"  />
            </div>
            <div class="col-sm-2" :hidden="targetOnlyMode">
              <label>Bx:</label>
              <input type="number" class="form-control" v-model="addingData.bx"  />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-6">
              <div class="form-group mb-0">
                <label>Data/ora (Formato: 1999-06-24 18:53): </label>
                <input type="text" class="form-control" v-model="showedTimeStamp"  
                  :class="{ 'is-invalid': !isTimestampValid && (showedTimeStamp.length > 15 || showedTimeStamp.length < 16 ) }" />
                <div v-if="!isTimestampValid && showedTimeStamp.length > 0" class="invalid-feedback">
                  ⚠️ **Formato non corretto.** Usa: YYYY-MM-DD HH:mm (es: 1999-06-24 18:53)
                </div>
              </div>
            </div>

            <div class="col-sm-3 d-flex align-items-end">
              <b-button size="sm" variant="success" @click="addDataRow">Aggiungi</b-button>
            </div>
          </div>


      </div>

    </div>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: "LotLogDetails",
  props: {
    lotlog: { type: Object, default: () => null }
  },
  data() {
    return {
      showData: true,
      showedTimeStamp: moment().format("YYYY-MM-DD HH:mm"),
      targetOnlyMode: false,
      addingData: {
        
        temperature: 0,
        targetTemperature: 0,
        AlcholEbul: 0,
        bx: 0
      },
      tableColumns: [ {
          label: 'Time',
          field: 'timesamp',
        },{
          label: 'T',
          field: 'temperature',
        },{
          label: 'T Target',
          field: 'targetTemperature',
        },{
          label: 'Al',
          field: 'AlcholEbul',
        },{
          label: 'Bx',
          field: 'bx',
        },{
          label: 'Azioni',
          field: 'actions',
        }
      ],
    }
  },
  methods: {
    isFieldDisabled(field) {
      if (this.targetOnlyMode) {
        return field !== 'targetTemperature';
      }
      return field === 'targetTemperature';
    },
    addDataRow() {

      if (!this.lotlog.data ) this.lotlog.data = [];

      this.addingData.timesamp = moment(this.showedTimeStamp, "YYYY-MM-DD HH:mm", true);
      if (!this.addingData.timesamp.isValid()) {
        this.$bvToast.toast('Data/ora non valida', {
          title: 'Errore',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2000,
          noCloseButton: false, // Ensures the close button is visible
        });
        return;
      }
      

      

      this.lotlog.data.push({
        timesamp: this.showedTimeStamp,//new Date(),
        temperature: this.addingData.temperature,
        targetTemperature: this.addingData.targetTemperature,
        AlcholEbul: this.addingData.AlcholEbul,
        bx: this.addingData.bx
      })
      
    },
    deleteRow(_rowIndex) {
      //console.log(_rowIndex);
      this.lotlog.data.splice(_rowIndex,1);

    },
  },
  computed: {
    isTimestampValid() {
      const timestampString = this.showedTimeStamp.trim();
      const expectedFormat = 'YYYY-MM-DD HH:mm';
      
      // 1. Basic check: If empty, consider it valid until required on form submission
      if (timestampString === '') {
        return true; 
      }

      // 2. Format and Validity Check using Moment.js
      // moment(input, format, strict_mode_boolean).isValid()
      // The 'true' argument enforces strict parsing:
      // - The input must exactly match the format (e.g., no extra chars).
      // - The date values must be valid (e.g., no February 30th).
      const isValid = moment(timestampString, expectedFormat, true).isValid();
      
      return isValid;
    }
  },
  watch:{
    lotlog: {
      immediate: true,
      handler(val) {
        if (val && typeof val.desiredAlcohol === 'undefined') {
          this.$set(val, 'desiredAlcohol', null);
        }
        if (val && typeof val.desiredReadyDate === 'undefined') {
          this.$set(val, 'desiredReadyDate', null);
        }
        if (val && (typeof val.alcholTollerance === 'undefined' || val.alcholTollerance === null)) {
          this.$set(val, 'alcholTollerance', 0.5);
        }
      }
    },
    "lotlog.status"(new_val) {
      if(new_val === 'CLOSED'){
        this.lotlog.endDate = new Date();
        //console.log('Impostata Data Chiusura automatica');

      }
      //this.intervention && (this.intervention.scheduledMaintenance = {
      //  "checkList": []
      //})
    }
  }
}
</script>
